import { render, staticRenderFns } from "./RHKPIPeriodicidades.vue?vue&type=template&id=13d0cb22&scoped=true"
import script from "./RHKPIPeriodicidades.vue?vue&type=script&lang=js"
export * from "./RHKPIPeriodicidades.vue?vue&type=script&lang=js"
import style0 from "./RHKPIPeriodicidades.vue?vue&type=style&index=0&id=13d0cb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d0cb22",
  null
  
)

export default component.exports